module.exports = __webpack_public_path__ + "static/dashboard@2x-38b0eae5408523ce30b14ec0f87abe7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/labs/dashboard@2x.jpg
// module id = 2653
// module chunks = 134932258599989